import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=98e5b608&scoped=true"
import script from "./AppNotifications.vue?vue&type=script&lang=js"
export * from "./AppNotifications.vue?vue&type=script&lang=js"
import style0 from "./AppNotifications.vue?vue&type=style&index=0&id=98e5b608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e5b608",
  null
  
)

export default component.exports